// extracted by mini-css-extract-plugin
module.exports = {"root":"ProfessionalCard_root__UVvsM","inner":"ProfessionalCard_inner__1pVS8","name":"ProfessionalCard_name__3JCPz","role":"ProfessionalCard_role__1lnY5"};